import React, { useState, useEffect } from 'react'
import { Modal, Table, Button } from 'antd'
import './index.less'

export interface ChannelSettingsProps {
	visible?: boolean;
	handleVisible?: (val: boolean) => void;
}

const ChannelSettings: React.Fc<ChannelSettingsProps> = ({
	visible,
	handleVisible,
}) => {
	const [dataList, setDataList] = useState([])
	const [currentPage] = useState(1)
	const [pageSize] = useState(5)
	const [total] = useState(5)

	const getData = async () => {
		const data = [
			{ id: 123, type: '公众号', name: '同程艺龙公众号', time: '2020.04.02', status: '未下发' }
		]
		setDataList(data)
	}

	useEffect(() => {
		getData()
	}, [])

	const handleModalVisible = (val: boolean) => {
		handleVisible(val)
	}

	const handleConfirm = () => {
		handleModalVisible(false)
	}

	const handleCancel = () => {
		handleModalVisible(false)
	}

	const cancelOne = (record) => {
		//
	}

	const updateOne = (record) => {
		//
	}

	const deleteOne = (record) => {
		//
	}

	const onPageChange = (page: number) => {

	}

	const columns = [
		{
			title: '序号',
			width: 60,
			render: (text, record, index) => <span>{pageSize * (currentPage - 1) + (index + 1)}</span>,
		},
		{
			title: '渠道类型',
			dataIndex: 'type',
			width: 88,
			ellipsis: true,
		},
		{
			title: '渠道名称',
			dataIndex: 'name',
		},
		{
			title: '自动下发时间',
			dataIndex: 'time',
			width: 116,
		},
		{
			title: '下发状态',
			dataIndex: 'status',
			width: 102,
		},
		{
			title: '操作',
			dataIndex: 'operation',
			width: 140,
			render: (text, record) => <>
				<Button type="link" onClick={() => updateOne(record)}>修改</Button>
				<Button type="link" onClick={() => cancelOne(record)}>取消</Button>
				<Button type="link" onClick={() => deleteOne(record)}>删除</Button>
			</>
		},
	]
	return (
		<Modal
			title="渠道编辑"
			className="channel-settings"
			visible={visible}
			onOk={handleConfirm}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>取消</Button>,
				<Button key="new" type="primary">新建</Button>,
				<Button key="confirm" onClick={handleConfirm}>确定</Button>
			]}
			centered
		>
			<Table
				rowKey="id"
				columns={columns}
				dataSource={dataList}
				pagination={{
					pageSize,
					total,
					onChange: onPageChange,
				}}
			/>
		</Modal>
	)
}

export default ChannelSettings